import { Button } from '@/ui-library';

import type { TemplateCardProps } from '../flow-templates.types';
import { TemplateAppIconGroup } from './template-app-icon-group.component';

export const TemplateCard: React.FC<TemplateCardProps> = (props) => {
  const { template, integration, isCloning, onCloneTemplate } = props;

  return (
    <div
      className='flex flex-col gap-4 bg-white ring-NeutralLightDark ring-1 w-full h-full rounded-xl p-6'
      data-testid={template.title}>
      <div className='flex justify-between items-start gap-2 flex-wrap'>
        <TemplateAppIconGroup templateNodes={template.nodes} />
        {template.comingSoon && <ComingSoonBadge />}
      </div>
      <div className='flex-1'>
        <p className='text-NeutralDarkMedium text-sm not-italic font-medium leading-6 line-clamp-3'>{template.title}</p>
      </div>
      <Button
        isLoading={isCloning}
        disabled={isCloning || template.comingSoon}
        onClick={() => onCloneTemplate(integration, template.name)}>
        Start with this template
      </Button>
    </div>
  );
};

const ComingSoonBadge: React.FC = () => (
  <div className='bg-NeutralDarkLightest text-NeutralLightLightest rounded-md items-center text-center justify-center py-1 px-1.5 text-xs h-auto line-clamp-1 truncate'>
    Coming soon
  </div>
);
